import styled, { css } from 'styled-components'

interface LayoutProps {
  layout: 'bulk' | 'individual'
}

interface WeightCounterProps extends LayoutProps {
  error: boolean
}

export const SelectionBox = styled.div<LayoutProps>`
  ${({ layout }) => layout === 'bulk' ? css`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    @media (max-width: 959.95px) {
      grid-template-columns: 1fr;
    }
  ` : css`
    display: flex;
    justify-content: center;
    align-items: center;
  `}
`

export const Column = styled.div<LayoutProps>`
  font-family: 'Roboto', sans-serif;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  min-width: 0;
  ${({ layout }) => layout === 'individual' && 'padding: 15px;'}
`

export const Header = styled.div<LayoutProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  ${({ layout }) => layout === 'bulk' && 'min-height: 34px;'}

  > div {
    display: flex;
    align-items: center;
  }

  h1,
  h2 {
    font-size: 16px;
    color: #56676f;
    ${({ layout }) => layout === 'bulk' && 'margin: 0;'}
  }

  span {
    background-color: #eeeeee;
    color: #65747b;
    border-radius: 5px;
    font-weight: 600;
    font-size: 12px;
    margin-left: 10px;
    padding: 4px 7px;
  }
`

export const List = styled.ul<LayoutProps>`
  list-style: none;
  border: 2px solid #eeeeee;
  width: ${({ layout }) => layout === 'bulk' ? '100%' : '38vw'};
  max-width: ${({ layout }) => layout === 'bulk' ? 'none' : '400px'};
  height: 250px;
  padding: 16px;
  border-radius: 8px;
  background: #fff;
  display: flex;
  overflow-y: ${({ layout }) => layout === 'bulk' ? 'auto' : 'scroll'};
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  margin: ${({ layout }) => layout === 'bulk' ? '5px 0 0' : '5px 0'};
  ${({ layout }) => layout === 'bulk' ? css`
    scrollbar-width: thin;
    scrollbar-color: #b5b5b5 transparent;
  ` : css`
    -ms-overflow-style: none;
    scrollbar-width: 4px;
    scrollbar-color: #b5b5b5;
  `}

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #b5b5b5;
    border-radius: 50px;
  }

  ${({ layout }) => layout === 'individual' && css`
    li + li {
      margin-top: 13px;
    }
  `}
`

export const WeightCounter = styled.div<WeightCounterProps>`
  background: #f5f6f8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${({ error }) => error ? 'red' : '#27ae60'};
  padding: 4px 8px;
  border-radius: 30px;
  margin: 0 6px;
  ${({ layout }) => layout === 'bulk' && 'cursor: default;'}
  transition: 0.3s ease-in;

  div {
    display: flex;
    align-items: center;
  }

  h3 {
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 0 2px;
    cursor: default;
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #e2e4e9;
    border: none;
    border-radius: 50%;
    padding: 2px;
    cursor: pointer;
    margin-left: 16px;
    width: 20px;
    height: 20px;
    transform: scale(1.2);
  }
`
